/**
 * Floor isolation toggle property.
 *
 * Storage key: identifier=`floor-isolation.{floorGroupIdentifier}`, objectIdentifier=`toggles`, type=PROJECT_USER
 *
 * Controls whether the 3D scene clips to isolate the selected floor.
 */

import { PropertyType, PropertyValueType } from '../../types';
import { propertyRegistry } from '../../PropertyRegistry';
import { ReactiveProperty } from '../../reactive/ReactiveProperty';
import { getGlobalPropertyService, hasGlobalPropertyService } from '../../reactive/globalPropertyService';

export const FLOOR_ISOLATION_TOGGLE_OBJECT_ID = 'toggles';

export function ensureFloorIsolationPropertyRegistered(floorGroupIdentifier: string): string {
  const propertyIdentifier = `floor-isolation.${floorGroupIdentifier}`;

  if (!propertyRegistry.isRegistered(propertyIdentifier)) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_USER,
      valueType: PropertyValueType.BOOLEAN,
      identifier: propertyIdentifier,
      name: `floor isolation for ${floorGroupIdentifier}`,
      annotationTypes: [],
      defaultValue: false,
    });
  }

  return propertyIdentifier;
}

export function getFloorIsolationProperty(floorGroupIdentifier: string): ReactiveProperty<boolean> | null {
  if (!hasGlobalPropertyService()) return null;

  const propertyIdentifier = ensureFloorIsolationPropertyRegistered(floorGroupIdentifier);
  const service = getGlobalPropertyService();
  return service.getProperty(propertyIdentifier, FLOOR_ISOLATION_TOGGLE_OBJECT_ID, PropertyType.PROJECT_USER) as ReactiveProperty<boolean>;
}
